import { useEffect, useState } from 'react'
import Header from 'components/Header/Header'
import './style.css'
import { FullpageContainer, FullpageSection } from '@shinyongjun/react-fullpage'
import '@shinyongjun/react-fullpage/css'
import First from 'components/Main/Fisrt'
import Second from 'components/Main/Second'
import Third from 'components/Main/Third'
import Fourth from 'components/Main/Fourth'
import Team from 'components/Main/Team'
import { mainActiveIndexAtom } from 'atom/main'
import { useAtom } from 'jotai'

const Main = () => {
  const [activeIndex, setActiveIndex] = useAtom(mainActiveIndexAtom)
  const [isPrev, setIsPrev] = useState<boolean>(true)
  const [isNext, setIsNext] = useState<boolean>(true)
  const [isFirst, setIsFirst] = useState<boolean>(true)

  useEffect(() => {
    if (isFirst) {
      setTimeout(() => {
        setIsFirst(false)
      }, 150)
    }
  }, [])

  return (
    <>
      <Header isOverLay={[2, 4, 5, 6].includes(activeIndex)} isWhite={false} bgWhite={[2, 4, 5, 6].includes(activeIndex)} />

      <FullpageContainer
        allowScrollDown={isNext}
        allowScrollUp={isPrev}
        activeIndex={activeIndex}
        transitionDuration={isFirst ? 0 : undefined}
        setActiveIndex={setActiveIndex}>
        <FullpageSection>
          <First activeIndex={activeIndex} />
        </FullpageSection>

        <FullpageSection>
          <Second
            activeIndex={activeIndex}
            setIsPrev={setIsPrev}
            setIsNext={setIsNext}
          />
        </FullpageSection>

        <FullpageSection>
          <Third />
        </FullpageSection>

        <FullpageSection>
          <Fourth
            activeIndex={activeIndex}
          />
        </FullpageSection>

        <FullpageSection>
          <Team
            activeIndex={activeIndex}
            num={0}
          />
        </FullpageSection>

        <FullpageSection>
          <Team
            activeIndex={activeIndex}
            num={1}
          />
        </FullpageSection>

        <FullpageSection>
          <Team
            activeIndex={activeIndex}
            num={2}
          />
        </FullpageSection>
      </FullpageContainer>
    </>
  )
}

export default Main
